export default __webpack_public_path__ + "static/media/loading.37617537.gif";